module.exports = __webpack_public_path__ + "img/rte.6f3aa385.png";